<template>
  <div class="assessment_result">
    <div class="assessment_result_header">
      <div class="assessment_result_header_left" @click="$router.push({ path: '/multiomics' })">
        <i class="iconfont iconfanhui"></i>
        <p>返回</p>
      </div>
    </div>
    <div class="assessment_result_listBox">
      <div class="assessment_result_list" v-for="(item, index) in list" :key="index" @click="$router.push({path: '/assessmentResultDetail/' + item.disease_name})">
        <div class="assessment_result_list_top">
          <div class="assessment_result_list_left">
            <img :src="item.url" alt="">
          </div>
          <div class="assessment_result_list_right">
            <p class="assessment_result_list_title">{{ item.disease_name }}</p>
            <p class="assessment_result_list_message">{{ item.disease_brief }}</p>
          </div>
        </div>
        <p class="assessment_result_list_a">查看结果 >></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'result',
  data () {
    return {
      list: []
    }
  },
  methods: {
    getList () {
      this.util.get(this.api.assessment_risk_list + '?type=2&intotype=0', '', (success) => {
        this.list = success
      })
    }
  },
  mounted () {
    this.getList()
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/functions";
  .assessment_result {

    .assessment_result_header {
      width: 100%;
      height: pxToRem(447px);
      background: url("../../assets/images/assessment/assessment-2.png");
      background-size: cover;
      background-position: center;
      margin-bottom: pxToRem(30px);

      .assessment_result_header_left {
        display: flex;
        padding-left: pxToRem(10px);
        width: pxToRem(120px);
        height: pxToRem(88px);
        line-height: pxToRem(88px);
        color: #fff;
      }
    }

    .assessment_result_listBox {
      padding: pxToRem(10px) pxToRem(30px);

      .assessment_result_list {
        width: 100%;
        padding: pxToRem(40px) pxToRem(20px);
        background-color: #fff;
        border-radius: pxToRem(30px);
        margin-bottom: pxToRem(20px);

        .assessment_result_list_top {
          display: flex;
          align-items: center;

          .assessment_result_list_left {
            margin-right: pxToRem(20px);

            img {
              width: pxToRem(125px);
            }
          }
        }

        .assessment_result_list_right {

          .assessment_result_list_title {
            font-size: pxToRem(35px);
            color: #000;
            margin-bottom: pxToRem(15px);
          }

          .assessment_result_list_message {
            font-size: pxToRem(25px);
            color: #595757;
          }
        }

        .assessment_result_list_a {
          font-size: pxToRem(20px);
          text-align: right;
          color: #0586C0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/assessment/result.vue